export type PillTone =
    | 'neutral'
    | 'info'
    | 'success'
    | 'warning'
    | 'danger'
    | 'primary'
    | 'secondary';

/**
 * Clinical statuses are passed through from DrChrono and the API docs do not
 * enumerate them, so these are lookups with a neutral fallback rather than
 * exhaustive records — an unrecognised status must still render.
 */
const fromMap = (map: Record<string, PillTone>, value: string | null | undefined): PillTone =>
    (value && map[value.toLowerCase()]) || 'neutral';

export const clinicalStatusTone = (status: string | null | undefined) =>
    fromMap(
        {
            active: 'info',
            inactive: 'neutral',
            resolved: 'success',
            remission: 'success',
            chronic: 'warning',
            recurrence: 'warning',
            relapse: 'warning'
        },
        status
    );

export const allergyStatusTone = (status: string | null | undefined) =>
    fromMap({ active: 'danger', inactive: 'neutral', resolved: 'success' }, status);

export const enrollmentStatusTone = (status: string | null | undefined) =>
    fromMap({ enrolled: 'success', disenrolled: 'danger', pending: 'warning' }, status);
